import { useMemo } from 'react';
import { rem } from 'design-system/values';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import useStyles from 'hooks/useStyles';
import { useMarginBottom } from 'hooks/useMarginBottom';
import createStyleSheets from 'utils/createStyleSheets';
import { HEIGHT_PLUS_PADDING } from 'design-system/Button';
import { isWeb } from '../../../constants';
const styleSet = createStyleSheets((colors) => ({
    header: {
        backgroundColor: 'transparent',
    },
    withPadding: {
        paddingHorizontal: rem(16),
    },
    containerNoPadding: {
        flex: 1,
        backgroundColor: colors.background.dark,
    },
    containerNoPaddingWhite: {
        flex: 1,
        backgroundColor: colors.background.light,
    },
    containerNoPaddingPurple: {
        flex: 1,
        backgroundColor: colors.background.brand,
    },
    containerNoPaddingTransparent: {
        flex: 1,
    },
    button: {
        position: 'absolute',
        left: rem(16),
        right: rem(16),
    },
    mountedButton: {
        position: 'absolute',
        left: rem(16),
        right: rem(16),
        bottom: rem(16),
    },
    separator: {
        height: 1,
        backgroundColor: colors.background.dark,
    },
    flexEnd: {
        paddingRight: rem(16),
        marginBottom: rem(6),
        alignItems: 'flex-end',
    },
    keyboardAvoidingView: {
        flex: 1,
    },
}));
export const useCommonInvestStyles = (isInTab = false) => {
    const commonStyles = useStyles(styleSet);
    const bottom = useMarginBottom('bottom');
    const paddingBottom = useMarginBottom('paddingBottom');
    const paddingBottomWithBottomSafeArea = useMarginBottom('paddingBottom', HEIGHT_PLUS_PADDING);
    const { paddingHorizontal } = useAppFrameDimensions(isInTab || isWeb);
    const withPadding = useMemo(() => ({
        ...commonStyles,
        contentContainer: {
            paddingHorizontal,
            ...paddingBottomWithBottomSafeArea,
        },
        contentContainerWithBottomSafeArea: {
            paddingHorizontal,
            ...paddingBottom,
        },
        button: {
            ...commonStyles.button,
            left: rem(16) + (paddingHorizontal || 0),
            right: rem(16) + (paddingHorizontal || 0),
            ...bottom,
        },
        mountedButton: {
            ...(paddingHorizontal ? commonStyles.button : commonStyles.mountedButton),
            bottom: rem(16),
            left: rem(16) + (paddingHorizontal || 0),
            right: rem(16) + (paddingHorizontal || 0),
        },
    }), [bottom, commonStyles, paddingBottom, paddingBottomWithBottomSafeArea, paddingHorizontal]);
    return withPadding;
};
export default styleSet;
